import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import "react-datetime/css/react-datetime.css";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Form, FormGroup } from "reactstrap";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import moment from "moment";
import _ from "lodash";

import {
  InputText,
  Dropdown,
  Loading,
  InputAmount,
  Valert,
  Vmodal,
  VautoComplete,
  DateTimePicker,
  ListingText,
  InputHHMM,
} from "../components";
import {
  SYMPTOM_UNITS_NEW,
  ACTIVITY_UNITS,
  PCP_UNITS,
  DRUG_UNITS,
  SUP_UNITS,
  FOOD_UNITS,
  LOC_UNITS,
} from "../actions/constant";
import { loginRequired } from "../services/UserService";
import editSymptomActions from "../actions/editSymptomActions";
import { getLoggedInUser } from "../services/AuthenticationService";
import "./styles/symptoms.css";
import "./styles/symptomsModern.css";
import { checkInput, SetupPageWithBFCacheAndPrompt, compressImageSmart, sanitizeEncodeImage } from "../lib/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";

class SearchSymptomForm extends Component {
  state = {
    dlModal: false,
    displayExport: false,
    // initialize searchBtn & showUpdate from props
    searchBtn: this.props.disabled.searchBtn,
    showUpdate: this.props.cancelMode || !this.props.disabled.addBtn,
    // we’ll keep the last dropdown values here so we can “replay” them if the user
    // says “cancel” in the Valert
    last: {
      user: "",
      category: "",
      to: "",
    },
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.disabled.searchBtn !== prevState.searchBtn) {
      return { searchBtn: nextProps.disabled.searchBtn };
    }
    return null;
  }

  // generic helper for “you have unsaved changes?” logic
  showUnsaved = (alertRef, onOk) => {
    const { disabled, itemChanged, updatedList } = this.props;
    if (!disabled.addBtn || itemChanged) {
      // compute new showUpdate
      const showUpdate = !disabled.addBtn || itemChanged;
      this.setState({ showUpdate });
      alertRef.changeStatus();
    } else if (updatedList) {
      this.setState({ showUpdate: false });
      alertRef.changeStatus();
    } else if (onOk) {
      onOk();
    }
  };

  // unified dropdown handler for user/to
  handleDropdown = (e, fieldName, alertRef, applyChange) => {
    const value = e.target.value;
    this.setState(({ last }) => ({
      last: { ...last, [fieldName]: value },
    }));
    this.showUnsaved(alertRef, () => {
      applyChange(e);
    });
  };

  // special for category (calls categorySelected instead of onChangeSearchForm)
  handleCategory = e => {
    const value = e.target.value;
    this.setState(({ last }) => ({
      last: { ...last, category: value },
    }));
    this.showUnsaved(this.resetFormalert4, () => {
      this.props.categorySelected(e);
    });
  };

  // date dropdown handler
  handleDate = e => {
    this.eDate = e;
    const startDate = moment(this.props.searchForm.exportStart).format("DD-MM-YYYY");
    const changedDate = moment(e).format("DD-MM-YYYY");

    if (
      (this.props.itemChanged || this.props.updatedList)
      && startDate !== changedDate
    ) {
      this.showUnsaved(this.resetFormalert5);
    } else if (startDate !== changedDate) {
      this.props.onDateChangeSearch(e);
    }
  };

  searchData = () => {
    if (this.props.searchMode) {
      // just submit
      setTimeout(() => this.props.submit(), 10);
    } else {
      this.setState({ displayExport: true });
      this.showUnsaved(this.resetFormalert2, () => {
        this.setState({ dlModal: true });
      });
    }
  };

  onExport = () => {
    this.setState({ dlModal: false });
    this.props.symptomExport({
      exportStart: this.props.searchForm.exportStart,
      category: this.props.searchForm.category,
      end: this.props.searchForm.toExport,
      user: this.props.searchForm.user,
    });
  };

  // Put this on the class (bind if needed), or as a class field:
  resetExportModal = () => {
    // 1) Clear the start date (DateTimePicker onChange)
    //    Most of your pickers accept null to clear.
    this.props.exportDateChanges(this.props.searchForm.start);

    // 2) Clear the "toExport" dropdown using your existing onChangeSearchForm signature
    this.props.onChangeSearchForm({
      target: { name: "toExport", value: "null" }, // keep your "null" sentinel
    });

    // 3) Close the modal
    this.setState({ dlModal: false });
  };


  render() {
    const { categories, ListOfWhile, users, searchForm, disabled, t } = this.props;
    const { searchBtn, showUpdate, last } = this.state;
    return (
      <Form onSubmit={this.props.handleSubmit}>
        {/* 1. USER dropdown */}
        <FormGroup row>
          <Col>
            <Field
              name="user"
              component={Dropdown}
              options={users}
              placeholder={t("symptoms.USERS")}
              onChange={e =>
                this.handleDropdown(
                  e,
                  "user",
                  this.resetFormalert3,
                  this.props.onChangeSearchForm
                )
              }
              val={searchForm.user || ""}
            />
          </Col>
          {/* 2. CATEGORY dropdown */}
          <Col>
            <Field
              name="category"
              component={Dropdown}
              options={categories}
              placeholder={t("symptoms.CATEGORY_TEXT")}
              onChange={this.handleCategory}
              val={searchForm.category || ""}
            />
          </Col>
        </FormGroup>

        {/* DATE RANGE */}
        <FormGroup row>
          <Col xs="6">
            <DateTimePicker
              name="start"
              placeholder={t("general.FROM_DATE_TEXT")}
              value={moment(searchForm.start)}
              onChange={this.handleDate}
              dateFormat="DD MMM YYYY"
              timeDisable="true"
              disableFutureDates={true}
              disabled={disabled.start}
            />
          </Col>
          <Col xs="4">
            <Field
              name="to"
              component={Dropdown}
              disabled={disabled.to}
              options={ListOfWhile}
              placeholder={t("general.NUMBER_OF_DAYS_TEXT")}
              onChange={e =>
                this.handleDropdown(
                  e,
                  "to",
                  this.resetFormalert6,
                  this.props.onChangeSearchForm
                )
              }
              val={searchForm.to}
            />
          </Col>
          <Col xs="2">
            <button
              type="button"
              className="btn btn-primary btnWide editInputSearchBtn"
              disabled={searchBtn}
              onClick={this.searchData}
            >
              {this.props.searchMode
                ? <i className="fa fa-search" />
                : <i className="fas fa-file-export" />}
            </button>
          </Col>
        </FormGroup>

        {/**— now all five of your Valerts follow the exact same pattern —**/}
        {["2", "3", "4", "5", "6"].map(num => (
          <Valert
            key={num}
            display={false}
            title={t("editsymptoms.UNSAVED_EDITED_ONEXPORT_TITLE")}
            question={
              !showUpdate
                ? t("editsymptoms.UNSAVED_EDIT_TEXT")
                : t("editsymptoms.UNSAVED_EDITED_ONEXPORT_TEXT")
            }
            onRef={ref => this[`resetFormalert${num}`] = ref}
            disableAutoClose
            positiveAction={() => {
              if (showUpdate) {
                if (!this.props.updatedList) {
                  this[`resetFormalert${num}`].changeStatus();
                  if (this.state.displayExport) {
                    // ✅ Deselect the selected item in the background
                    this.props.symptomSelected(
                      this.props.selectedItem.orgItem,
                      this.props.selectedItem.category,
                      this.props.selectedIndex
                    );

                    // ✅ Open the export modal
                    this.setState({ displayExport: false });
                    this.setState({ dlModal: true });
                  } else {
                    const field = num === "2" ? null : num === "5" ? this.eDate : last[{ "3": "user", "4": "category", "6": "to" }[num]];
                    this[`resetFormalert${num}`].changeStatus();
                    if (num === "5") return this.props.onDateChangeSearch(this.eDate);
                    if (num === "4") return this.props.categorySelected({ target: { name: "category", value: last.category } });
                    this.props.onChangeSearchForm({ target: { name: { "3": "user", "6": "to" }[num], value: last[{ "3": "user", "6": "to" }[num]] } });
                  }
                }
                this.setState({ showUpdate: false });
              } else {
                // replay last value
                const field = num === "2" ? null : num === "5" ? this.eDate : last[{ "3": "user", "4": "category", "6": "to" }[num]];
                this[`resetFormalert${num}`].changeStatus();
                if (num === "5") return this.props.onDateChangeSearch(this.eDate);
                if (num === "4") return this.props.categorySelected({ target: { name: "category", value: last.category } });
                this.props.onChangeSearchForm({ target: { name: { "3": "user", "6": "to" }[num], value: last[{ "3": "user", "6": "to" }[num]] } });
              }
            }}
            negativeAction={() => {
              this.setState({ displayExport: false });
              this.setState({ dlModal: false });
              this[`resetFormalert${num}`].changeStatus();
              const name = { "2": "to", "3": "user", "4": "category", "5": "start", "6": "to" }[num];
              this.props.resetNegativeFunction(name);
            }}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
          />
        ))}

        {/** EXPORT MODAL **/}
        <Vmodal
          displayStatus={this.state.dlModal}
          data={(
            // marginLeft: 15, marginRight: 15, paddingTop: 20
            <div style={{ width: 350, paddingTop: 25 }}>


              {/* Title */}
              <h4 style={{ fontWeight: 700, margin: "0 0 13px 0" }}>
                {this.props.t("editsymptoms.EXPORT_DATA_TITLE")}
              </h4>

              {/* Body text */}
              <p style={{ margin: "0 0 25px 0", lineHeight: 1.4 }}>
                {this.props.t("editsymptoms.EXPORT_DATA_TEXT")}
              </p>

              <FormGroup row>
                <Col xs="6">
                  <DateTimePicker
                    zIndex={8}
                    name="exportStart"
                    placeholder={this.props.t("general.FROM_DATE_TEXT")}
                    value={moment(this.props.searchForm.exportStart)}
                    onChange={this.props.exportDateChanges}
                    dateFormat="DD MMM YYYY"
                    timeDisable="true"
                    disableFutureDates={true}
                    disabled={false}
                  />
                </Col>
                <Col xs="6">
                  <Field
                    name="toExport"
                    component={Dropdown}
                    disabled={false}
                    options={[
                      {
                        value: "1",
                        label: this.props.t("editsymptoms.1DAY_NUMBER_TEXT"),
                      },
                      {
                        value: "2",
                        label: this.props.t("editsymptoms.2DAYS_NUMBER_TEXT"),
                      },
                      {
                        value: "3",
                        label: this.props.t("editsymptoms.3DAYS_NUMBER_TEXT"),
                      },
                      {
                        value: "4",
                        label: this.props.t("editsymptoms.4DAYS_NUMBER_TEXT"),
                      },
                      {
                        value: "5",
                        label: this.props.t("editsymptoms.5DAYS_NUMBER_TEXT"),
                      },
                      {
                        value: "6",
                        label: this.props.t("editsymptoms.6DAYS_NUMBER_TEXT"),
                      },
                      {
                        value: "7",
                        label: this.props.t("editsymptoms.7DAYS_NUMBER_TEXT"),
                      },
                      {
                        value: "14",
                        label: this.props.t("editsymptoms.2WEEKS_OPTION_TEXT"),
                      },
                      {
                        value: "30",
                        label: this.props.t("editsymptoms.1MONTH_OPTION_TEXT"),
                      },
                    ]}
                    placeholder={this.props.t("general.NUMBER_OF_DAYS_TEXT")}
                    val={this.props.searchForm.toExport}
                    onChange={(e) => {
                      this.props.onChangeSearchForm(e);
                    }}
                  />
                </Col>
              </FormGroup>
              {/* <button
                style={{ float: "right", padding: "8px 25px", marginTop: 10 }}
                type="button"
                className="btn btn-primary"
                onClick={this.onExport.bind(this)}
                disabled={
                  this.props.searchForm.toExport &&
                    this.props.searchForm.toExport != "null"
                    ? false
                    : true
                }
              >
                {this.props.t("general.EXPORT_DATA_BUTTON")}
              </button> */}



              <div className="ButtonsContainer" style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.onExport.bind(this)}
                  disabled={
                    this.props.searchForm.toExport &&
                      this.props.searchForm.toExport != "null"
                      ? false
                      : true
                  }
                >
                  {this.props.t("general.EXPORT_DATA_BUTTON")}
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.resetExportModal}
                >
                  {this.props.t("general.CANCEL")}
                </button>
              </div>

            </div>)}
          closeFunc={this.resetExportModal}
        />
      </Form>
    );
  }
}
const mapSearchState = state => ({
  initialValues: state.editSymptom.searchForm,
  disabled: state.editSymptom.disabled,
  cancelMode: state.editSymptom.cancelMode,
});
SearchSymptomForm = reduxForm({
  form: "formEditSymptom",
  enableReinitialize: true,
  //keepDirtyOnReinitialize: false
})(SearchSymptomForm);

SearchSymptomForm = connect(mapSearchState)(SearchSymptomForm);

class EditSymptomForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: moment(),
      dlModal: false,
      posunits: undefined,
    };
    this.handleChange = this.handleChange.bind(this);
    this.forceSubmit = this.forceSubmit.bind(this);
    this.handleSemiColonInAmount = this.handleSemiColonInAmount.bind(this);
    this.ClearPageClicked = this.ClearPageClicked.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  componentWillReceiveProps(newProps) {
    this.setState({ time: newProps.symptomEditForm.time });
  }

  posunits(unit, cat) {
    let units = {};
    units.names = "";
    units.ids = [];
    let lsUnits = [];
    if (cat == "01") {
      lsUnits = SYMPTOM_UNITS_NEW();
    } else if (cat == "03") {
      lsUnits = ACTIVITY_UNITS();
    } else if (cat == "04") {
      lsUnits = PCP_UNITS();
    } else if (cat == "02") {
      lsUnits = FOOD_UNITS();
    } else if (cat == "05") {
      lsUnits = DRUG_UNITS();
    } else if (cat == "06") {
      lsUnits = SUP_UNITS();
    } else if (cat == "07") {
      lsUnits = LOC_UNITS();
    }
    if (cat === "02") {
      lsUnits.map((item) => {
        if (unit !== "135" && unit !== "125") {
          if (item._id !== "135" && item._id !== "125") {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        } else {
          if (item._id === unit) {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        }
      });
    } else if (cat === "03") {
      lsUnits.map((item) => {
        if (unit === "101" || unit === "102" || unit === "445") {
          if (item._id === "101" || item._id === "102" || item._id === "445") {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        } else if (unit === "103" || unit === "104") {
          if (item._id === "103" || item._id === "104") {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        } else {
          if (item._id === unit) {
            units.names += item.unit + ", ";
            units.ids.push(item._id);
          }
        }
      });
    } else {
      lsUnits.map((item) => {
        if (item._id === unit) {
          units.names += item.unit + ", ";
          units.ids.push(item._id);
        }
      });
    }
    units.names = units.names.slice(0, -2);
    return units;
  }

  // Helper function to flag incompatible unit
  findIncompatibleUnitForSelection(form, symptoms, helpers) {
    const { getSelectedKey, getSelectedKeyType, getItemCategory, getItemUnit, computeItemKey } = helpers;

    // The currently selected ROW in the Display Area (top-level id)
    const selectedRowId =
      (this.props.itemSelected &&
        this.props.itemSelected.orgItem &&
        this.props.itemSelected.orgItem._id) || null;

    // Local: policy gate (02/03 depend on key type; skip 01/07)
    const shouldCheckIncompatibleUnit = (f) => {
      const cat = f.category;
      if (cat === "01" || cat === "07") return false; // Symptom / Location: skip
      if (cat === "02" || cat === "03") {
        const t = getSelectedKeyType(f);
        return t === "upc" || t === "name"; // only when key is UPC/Name (not ID)
      }
      // 04/05/06 : always check
      return true;
    };

    if (!shouldCheckIncompatibleUnit(form)) return { incompatible: false, allowedNames: [] };

    const category = form.category;
    const selectedKey = getSelectedKey(form);
    const currentUnit = form.unit;

    let incompatible = false;
    let allowedNames = [];
    (symptoms || []).forEach((item) => {
      // Skip the current item whether referenced by inner id (form._id)
      // or by the row’s top-level id (selectedRowId)
      if (!item) return;
      if (String(item._id) === String(form._id)) return;
      if (selectedRowId && String(item._id) === String(selectedRowId)) return;

      const itemCategory = getItemCategory(item);
      if (itemCategory !== category) return;

      const itemKey = computeItemKey(item, itemCategory);
      if (itemKey !== selectedKey) return;

      const itemUnit = getItemUnit(item, itemCategory);
      const allowed = this.posunits(itemUnit, itemCategory); // { ids:[], names:[] }

      if (allowed.ids && !allowed.ids.includes(currentUnit)) {
        incompatible = true;
        allowedNames = allowed && allowed.names || [];
      }
    });

    return { incompatible, allowedNames };
  }

  UpdateItemClicked() {
    // ---------- Inline helpers (scoped to this submit only) ----------
    // collapse spaces, trim, and strip trailing (C)/(R) with any spacing/case
    const stripC = (s = "") =>
      String(s)
        .replace(/\s+/g, " ")
        .trim()
        .replace(/\s*\((c|r)\)\s*$/i, "")
        .trim()
        .toLowerCase();

    const form = this.props.symptomEditForm;
    const selected = this.props.itemSelected;

    const getSelectedKeyType = (form) => {
      if (form.symptom) return "symptom"; // ID
      if (form.upc) return "upc";     // UPC
      return "name";
    };

    const getSelectedKey = (form) =>
      form.symptom || form.upc || stripC(form.name);

    const getItemCategory = (item) =>
      item && item.status === 1 ? item && item.updatedData && item.updatedData.category : item && item.category;

    const getOriginalId = (item, itemCategory) => {
      const hasUpd = item && item.status === 1 && item && item.updatedData;
      if (hasUpd) {
        return itemCategory === "02"
          ? item && item.updatedData && item.updatedData.meals && item.updatedData.meals[0] && item.updatedData.meals[0]._id
          : item && item.updatedData && item.updatedData._id;
      }

      return (
        item && item.symptom ||  // 01
        item && item.pcp_id ||   // 04
        item && item.drug_id ||  // 05
        item && item.act_id ||   // 03
        item && item.item_id ||  // 06/07
        (itemCategory === "02" ? item && item.meals && item.meals[0] && item.meals[0]._id : undefined)
      );
    };

    const getNameAndUpc = (item, itemCategory) => {

      // ===== Symptom (01) =====
      if (itemCategory === "01") {
        // 1) Currently Selected Item: Use fullname from top layer. Leave upc blank
        if (item && item.orgItem) {
          return {
            name: (item && item.fullname) || "",
            upc: ""
          };
        }

        // 2) Updated Item: Use symptom_name from updatedData. Leave upc blank
        if (item && item.status === 1) {
          var symUpd = item && item.updatedData && item.updatedData.symptom_name;
          return {
            name: symUpd || "",
            upc: ""
          };
        }

        // 3) Others (not selected, not updated) Item: Use symptom_name from top layer. Leave upc blank
        return {
          name: (item && item.symptom_name) || "",
          upc: (typeof (item && item.upc) === "string" ? item.upc : "")
        };
      }

      // ===== Food (02) =====
      if (itemCategory === "02") {
        // 1) Currently Selected Item: Use fullname and upc from top layer
        if (item && item.orgItem) {
          return {
            name: item.fullname || "",
            upc: (typeof (item && item.upc) === "string" ? item.upc : "")
          };
        }

        // 2) Updated Item: Use recipe_full and upc from updatedData.meals[0]
        if (item && item.status === 1) {
          var umeals = item && item.updatedData && item.updatedData.meals;
          var umeal = (Array.isArray(umeals) && umeals.length && umeals[0]) ? umeals[0] : null;

          return {
            name: (umeal && umeal.recipe_full) || "",
            upc: (umeal && typeof umeal.upc === "string") ? umeal.upc : ""
          };
        }

        // 3) Others (not selected, not updated) Item: Use recipe_full and upc from meals[0]
        var meals = item && item.meals;
        var meal = (Array.isArray(meals) && meals.length && meals[0]) ? meals[0] : null;

        return {
          name: (meal && meal.recipe_full) || "",
          upc: (meal && typeof meal.upc === "string") ? meal.upc : ""
        };
      }

      // ===== Other categories (Activity (03), PCP (04), Medicine (05), Supplement (06), Location (07))=====
      // 1) Currently Selected Item: Use fullname and upc from top layer
      if (item && item.orgItem) {
        return {
          name: (item && item.fullname) || "",
          upc: (typeof (item && item.upc) === "string" ? item.upc : "")
        };
      }

      // 2) Updated Item: Use fullname and upc from updatedData
      if (item && item.status === 1) {
        var oName = item && item.updatedData && item.updatedData.fullname;
        var oUpc = item && item.updatedData && item.updatedData.upc;
        return {
          name: oName || "",
          upc: (typeof oUpc === "string" ? oUpc : "")
        };
      }

      // 3) Others (not selected, not updated) Item: Use recipe_full and upc from meals[0]
      return {
        name: (item && item.fullname) || "",
        upc: (typeof (item && item.upc) === "string" ? item.upc : "")
      };

    };

    const getItemUnit = (item, itemCategory) => {
      // Food (02): look inside meals[0]
      if (itemCategory === "02") {
        const data = item.status === 1
          ? item && item.updatedData && item.updatedData.meals && item.updatedData.meals[0]
          : item && item.meals && item.meals[0];

        return (
          (data && data.unitid) ||
          (Array.isArray(data && data.units) && data.units[0]) ||
          ""
        );
      }

      // All other categories (01,03,04,05,06,07)
      if (itemCategory !== "02") {
        const data = item.status === 1
          ? item && item.updatedData
          : item;

        return (
          (data && data.unitid) ||
          (Array.isArray(data && data.units) && data.units[0]) ||
          ""
        );
      }

      return (
        item.unitid ||
        (Array.isArray(item.units) && item.units[0]) ||
        ""
      );
      // return item && item.unitid || (item && item.units && item && item.units[0]) || "";
    };

    const computeItemKey = (item, itemCategory) => {
      const { name, upc } = getNameAndUpc(item, itemCategory);
      const originalID = getOriginalId(item, itemCategory);
      return originalID || upc || stripC(name); // ID > UPC > normalized name
    };

    // Build a “safe” form that always has an identifier you can rely on
    const formForCheck = {
      ...this.props.symptomEditForm,
      // prefer the form's _id, else fall back to the selected row's id(s)
      _id:
        this.props.symptomEditForm._id ||
        (this.props.itemSelected && (this.props.itemSelected._id ||
          (this.props.itemSelected.orgItem && this.props.itemSelected.orgItem._id))) ||
        "",
      // vId is very reliable for items in the display area; keep it too
      vId:
        this.props.symptomEditForm.vId ||
        (this.props.itemSelected && this.props.itemSelected.vId) ||
        "",
    };

    // Current form key (ID → UPC → normalized name)
    const nowKeyType = getSelectedKeyType(form);
    const nowKeyVal = nowKeyType === "name"
      ? stripC(form.fullname)
      : String(form[nowKeyType]).trim();
    const cleanedNewName = stripC(form.fullname);

    // Original item key (ID → UPC → normalized name)
    const itemCategory = getItemCategory(selected);
    const origId = getOriginalId(selected, itemCategory);
    const { name: origName, upc: origUpc } = getNameAndUpc(selected, itemCategory);

    const beforeKeyType = origId ? "symptom" : (origUpc ? "upc" : "name");
    const beforeKeyVal = origId
      ? String(origId).trim()
      : (origUpc ? String(origUpc).trim() : stripC(origName));

    // Key-equality: same type AND same value (non-empty)
    const hasNameChanged = !(
      beforeKeyType === nowKeyType &&
      beforeKeyVal &&
      nowKeyVal &&
      beforeKeyVal === nowKeyVal
    );

    const isDropdownAmount =
      Array.isArray(this.props.scaleOptions) &&
      this.props.scaleOptions.some(
        (opt) => String(opt.value) === String(this.props.symptomEditForm.scale)
      );

    const isCustomEntry = !form.symptom && !form.upc;

    const isAlreadyInDisplayArea = (this.props.symptoms || []).some((item) => {
      const itemCategory = getItemCategory(item);
      const origId = getOriginalId(item, itemCategory);
      const { name: itemName, upc: itemUpc } = getNameAndUpc(item, itemCategory);
      const cleanedItemName = stripC(itemName || "");
      const isCustomRow = !origId && !(String(itemUpc || "").trim().length > 0);

      // 1) Exclude the item being edited
      if (item && item._id === form._id) return false;

      // 2) Same category only
      if (String(itemCategory) !== String(form.category)) return false;

      // 3) Only compare with OTHER custom items (no ID, no UPC)
      if (origId || itemUpc) {
        return false;
      }

      // 4) Compare normalized names
      return cleanedItemName === cleanedNewName;
    });

    // ---------- 1) Incompatible Unit ----------
    const { incompatible, allowedNames } = this.findIncompatibleUnitForSelection(
      formForCheck,
      this.props.symptoms,
      {
        getSelectedKey,
        getSelectedKeyType,
        getItemCategory,
        getItemUnit,
        computeItemKey,
      }
    );

    if (incompatible) {
      this.setState({ posunits: allowedNames }); // for your VAlert display
      this.showDuplicateUnit.changeStatus();
      return false; // STOP chain
    }

    // ---------- 2) Invalid Value (non-dropdown only) ----------
    const amountValue = isDropdownAmount ? true : checkInput(this.props.symptomEditForm.scale, this.props.symptomEditForm.unit);

    if (!amountValue) {
      this.invalidValue.changeStatus();
      return false; // STOP chain
    }

    // ---------- 3) Value Too Small/Large ----------
    if (this.props.outOfRange) {
      // Queue 4) Not-in-DB only when custom + name changed
      this.pendingCustomCheck = () => {
        if (hasNameChanged && isCustomEntry && !isAlreadyInDisplayArea) {
          this.props.CustomItemNotIn12u12DB.changeStatus(this.props.symptomEditForm);
          return true;
        }
        this.props.submit();
        return true;
      };
      this.props.rangeCheck.changeStatus(); // VAlert will call pendingCustomCheck() on confirm
      return false;
    }

    // ---------- 4) Not in 12u12 DB ----------
    if (hasNameChanged && isCustomEntry && !isAlreadyInDisplayArea) {
      this.props.CustomItemNotIn12u12DB.changeStatus(this.props.symptomEditForm);
      return false;
    }

    // ---------- Submit ----------
    this.props.submit();
    return true;
  }

  forceSubmit() {
    this.props.submit();
  }

  searchNameOptions(e) {
    //alert(e);
    let val = e.target.value;
    this.props.searchNameOptions(val, this.props.itemSelected.category);
  }
  handleChange(val) {
    this.setState({ time: val });
    this.props.change("time", val.format("DD/MM/YYYY hh:mm a"));
  }
  handleSave() {
    if (!this.props.disabled.addBtn) {
      this.SelectedItemNotUpdated.changeStatus();
    } else if (this.props.cancelMode && this.props.itemChanged) {
      this.IncompleteChangeToSelectedItem.changeStatus();
    } else {
      this.props.savePage();
    }
  }

  handleSemiColonInAmount = (val) => {
    // Only flip if 445 is allowed by unitOptions
    const supportsHHMM = Array.isArray(this.props.unitOptions) && this.props.unitOptions.some(opt => String(opt.value) === "445");

    // If no HHMM unit, stop execution
    if (!supportsHHMM) return;

    // ✅ If HHMM unit, switch to HHMM mode
    this.props.setHHMMMode(true);

    // ✅ Auto-select HHMM unit if not already selected
    this.props.onChangeSyptomEditForm({ target: { name: "unit", value: "445" } });
  };

  ClearPageClicked() {
    if (this.props.disabled.saveBtn) {
      this.props.clearEditSymptom();
      window.location.reload();
    }
    else {
      this.ClearConfirmation.changeStatus();
    }
  }

  render() {
    const { barcode, itemSelected, symptomEditForm, searchForm } = this.props;

    const hasItems = Array.isArray(this.props.symptoms) && this.props.symptoms.length > 0;

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <Valert
          display={false}
          onRef={(ref) => (this.invalidValue = ref)}
          title={this.props.t("general.INVALID_VALUE_TITLE")}
          question={this.props.t("general.INVALID_VALUE_TEXT")}
          // positiveAction={}
          positiveText={this.props.t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.showDuplicateUnit = ref)}
          title={this.props.t("symptoms.MEASUREMENT_UNIT_PROMPT_TITLE")}
          question={
            this.props.t("symptoms.CHOOSE_UNIT_PROMPT_TEXT") +
            this.state.posunits +
            "."
          }
          positiveAction={() => {
            // this.setState({ posunits: undefined });
          }}
          positiveText={this.props.t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.SelectedItemNotUpdated = ref)}
          title={this.props.t("general.SELECTED_ITEM_TITLE")}
          question={this.props.t("general.SAVE_PAGE_UPDATED_DATA_ERROR_TEXT")}
          positiveAction={() => {
            this.props.savePage();
          }}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.IncompleteChangeToSelectedItem = ref)}
          title={this.props.t("general.INCOMPLETE_CHANGE_TITLE")}
          question={this.props.t("general.INCOMPLETE_CHANGE_TEXT")}
          positiveAction={() => {
            this.props.savePage();
          }}
        />
        <Valert
          display={false}
          question={this.props.t("symptoms.CLEAR_CONFIRMATION_TEXT")}
          title={this.props.t("general.CLEAR_CONFIRMATION_TITLE")}
          onRef={(ref) => (this.ClearConfirmation = ref)}
          positiveAction={() => {
            this.props.clearEditSymptom();
            window.location.reload();
          }}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />

        <Field component={InputText} type="hidden" name="_id" />
        <FormGroup row>
          <Col>
            <Field
              name="name"
              component={VautoComplete}
              disabled={this.props.disabled.name}
              placeholder={
                this.props.selectedCategory == "01"
                  ? this.props.t("symptoms.ITEM_INPUT_TEXT_SYMPTOM")
                  : this.props.selectedCategory == "02"
                    ? this.props.t("general.FOOD_PLACEHOLDER")
                    : this.props.selectedCategory == "03"
                      ? this.props.t("general.ACTIVITY_PLACEHOLDER")
                      : this.props.selectedCategory == "04"
                        ? this.props.t("general.PCP_PLACEHOLDER")
                        : this.props.selectedCategory == "05"
                          ? this.props.t("general.MEDICINE_PLACEHOLDER")
                          : this.props.selectedCategory == "06"
                            ? this.props.t("general.SUPPLEMENT_PLACEHOLDER")
                            : this.props.selectedCategory == "07"
                              ? this.props.t("general.LOCATION_PLACEHOLDER")
                              : this.props.t("general.ITEM_INPUT_TEXT")
              }
              onChangeText={(val) => {
                this.props.searchNameOptions(val, itemSelected.category);
              }}
              onSelect={this.props.symptomOptionSelected}
              val={symptomEditForm.fullname}
              category={
                itemSelected && itemSelected.category
                  ? itemSelected.category
                  : undefined
              }
              level="111111001"
              append={this.props.symptomEditForm.upc}
              sType={"6"}
              onClear={() => {
                this.props.searchNameOptions("", itemSelected.category, true);
              }}
              showCross={true}
              bodyMapClicked={
                (itemSelected &&
                  itemSelected.category == "01" &&
                  this.props.bodyMapClicked) ||
                (this.props.searchForm &&
                  this.props.searchForm.category == "01" &&
                  this.props.bodyMapClicked)
              }
              barcodeClicked={
                (this.props.symptomEditForm.category &&
                  (this.props.symptomEditForm.category === "02" ||
                    this.props.symptomEditForm.category === "04" ||
                    this.props.symptomEditForm.category === "05" ||
                    this.props.symptomEditForm.category === "06")) ||
                  (this.props.searchForm.category &&
                    (this.props.searchForm.category === "02" ||
                      this.props.searchForm.category === "04" ||
                      this.props.searchForm.category === "05" ||
                      this.props.searchForm.category === "06"))
                  ? this.props.barcodeClicked
                  : false
              }
              barcodeImageClicked={this.props.barcodeImageClicked}
              barcode={barcode}
              partialResult={this.props.partialResult}
              showPartial={
                this.props.partialResult && this.props.partialResult.length > 0
                  ? true
                  : false
              }
              barcodeSearch={this.props.barcodeSearch}
              showNoneOfAbove={true}
              showNoneOfAboveText={this.props.t("BARCODE.NONE_OF_ABOVE")}
              addCustomAlert={this.props.addCustomAlert}
              showHistory={false}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col>
            <Field
              name="unit"
              component={Dropdown}
              options={this.props.unitOptions}
              placeholder={
                this.props.unitOptions.length === 1
                  ? ""
                  : this.props.t("symptoms.ITEM_UNIT_TEXT") //"Unit"
              }
              disabled={this.props.disabled.unit}
              onChange={(e) => this.props.onChangeSyptomEditForm(e)}
              val={symptomEditForm.unit}
            />
          </Col>
          <Col>
            {this.props.scaleOptions.length !== 0 ? (
              // 1) Severity/scale dropdown when options available
              <Field
                name="scale"
                component={Dropdown}
                options={this.props.scaleOptions}
                placeholder={
                  this.props.symptomEditForm.category == "01"
                    ? this.props.t("general.ITEM_VALUE_TEXT_SYMPTOM")
                    : this.props.t("general.ITEM_VALUE_TEXT")
                }
                // placeholder={this.props.t("general.ITEM_VALUE_TEXT_SYMPTOM")}
                readOnly={this.props.disabled.input}
                disabled={this.props.disabled.scale}
                onChange={(e) => this.props.onChangeSyptomEditForm(e)}
                amounNewValue={this.props.amounNewValue}
                reseter={this.props.amountReseter}
              // val={this.props.symptomEditForm.scale}
              />
            ) : this.props.hhmmMode ? (
              // 2) 🕒 HH:MM entry when semicolon mode is active
              <Field
                key={`scale-hhmm-${this.props.amountReseter}`}
                component={InputHHMM}
                name="scale"
                placeholder_HH={this.props.t("general.ITEM_VALUE_TEXT_HH")}
                placeholder_MM={this.props.t("general.ITEM_VALUE_TEXT_MM")}
                className="hhmm-styled"
                disabled={this.props.disabled.scale}
                onChangeSymptomForm={(e) => this.props.onChangeSyptomEditForm(e)}
                semicolonTriggered={this.props.hhmmMode}
              />
            ) : (
              <Field
                key={`scale-text-${this.props.amountReseter}`}
                component={InputAmount}
                name="scale"
                placeholder={
                  (this.props.symptomEditForm.category &&
                    this.props.symptomEditForm.category == "01") ||
                    (this.props.searchForm.category &&
                      this.props.searchForm.category == "01")
                    ? this.props.t("general.ITEM_VALUE_TEXT_SYMPTOM")
                    : this.props.t("general.ITEM_VALUE_TEXT")
                }
                onRef={(ref) => (this.amountRef = ref)}
                disabled={this.props.disabled.scale}
                onKeyUp={(e) => this.props.onChangeSyptomEditForm(e)}
                reseter={this.props.amountReseter}
                mode="allowfraction"
                amounNewValue={this.props.amounNewValue || ""}
                className={`${this.state.scaleValidator && "is-invalid"}`}
                onSemiColonTyped={(val) => this.handleSemiColonInAmount(val)}
                HHMM_Allowed={
                  Array.isArray(this.props.unitOptions) &&
                  this.props.unitOptions.some(opt => String(opt.value) === "445")
                }
              />
            )}
          </Col>
        </FormGroup>
        <FormGroup>
          <DateTimePicker
            name="time"
            placeholder={
              (this.props.selectedIndex > -1 &&
                symptomEditForm &&
                symptomEditForm.category &&
                (symptomEditForm.category == "03" ||
                  symptomEditForm.category == "02")) ||
                this.props.selectedCategory == "03" ||
                this.props.selectedCategory == "02"
                ? this.props.t("symptoms.CALENDER_ACTIVITY_TEXT")
                : (this.props.selectedIndex > -1 &&
                  symptomEditForm &&
                  symptomEditForm.category &&
                  symptomEditForm.category == "07") ||
                  this.props.selectedCategory == "07"
                  ? this.props.t("symptoms.CALENDER_LOCATION_TEXT")
                  : this.props.selectedIndex == -1 &&
                    searchForm &&
                    searchForm.category &&
                    (searchForm.category == "03" || searchForm.category == "02")
                    ? this.props.t("symptoms.CALENDER_ACTIVITY_TEXT")
                    : this.props.selectedIndex == -1 &&
                      searchForm &&
                      searchForm.category &&
                      searchForm.category == "07"
                      ? this.props.t("symptoms.CALENDER_LOCATION_TEXT")
                      : this.props.t("symptoms.TIME_TEXT")
            }
            value={
              symptomEditForm.time
                ? symptomEditForm.time
                : ""
            }
            dateFormat="DD MMM YYYY, hh:mm A"
            disableFutureDates={true}
            disabled={this.props.disabled.time}
            onChange={(e) =>
              this.props.onChangeSyptomEditForm(
                (e = { target: { name: "time", value: e } })
              )
            }
            showLabel={true}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="comment"
            component={InputText}
            type="textarea"
            placeholder={this.props.t("products.COMMENT_DEFAULT_TEXT")}
            disabled={this.props.disabled.comment}
            onChange={(e) => this.props.onChangeSyptomEditForm(e)}
            maxLength={5000}
          />
        </FormGroup>
        <div className="button-spacer"></div>
        <FormGroup>
          <Row>
            <Col>
              {this.props.cancelMode ? (
                <button
                  type="button"
                  className="btn btn-primary btnWide"
                  onClick={() =>
                    this.props.symptomSelected(
                      this.props.itemSelected.orgItem,
                      this.props.itemSelected.category,
                      this.props.selectedIndex
                    )
                  }
                >
                  {this.props.t("general.CANCEL_ITEM_BUTTON")}
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary btnWide"
                  onClick={this.UpdateItemClicked.bind(this)}
                  disabled={this.props.disabled.addBtn}
                >
                  {this.props.t("general.UPDATE_ITEM_BUTTON")}
                </button>
              )}
            </Col>
            <Col>
              {this.props.updateMode && !this.props.cancelMode && (
                <button
                  type="button"
                  className="btn btn-primary btnWide"
                  onClick={() =>
                    this.props.symptomSelected(
                      this.props.itemSelected.orgItem,
                      this.props.itemSelected.category,
                      this.props.selectedIndex
                    )
                  }
                >
                  {this.props.t("general.CANCEL_ITEM_BUTTON")}
                </button>
              )}

              {!this.props.updateMode && (
                <button
                  type="button"
                  className="btn btn-primary btnWide"
                  onClick={() => {
                    this.handleSave();
                  }}
                  disabled={this.props.disabled.saveBtn}
                >
                  {this.props.t("general.SAVE_PAGE_BUTTON")}
                </button>
              )}
            </Col>
            <Col>
                <button
                  type="button"
                  className="btn btn-primary btnWide"
                  onClick={this.ClearPageClicked}
                  disabled={!hasItems && this.props.disabled.saveBtn}
                >
                  {this.props.t("general.CLEAR_PAGE_BUTTON")}
                </button>
            </Col>
          </Row>
          <span></span>
        </FormGroup>
      </Form>
    );
  }
}

EditSymptomForm = reduxForm({
  form: "formSymptom",
  enableReinitialize: true,
  //keepDirtyOnReinitialize: false,
})(EditSymptomForm);

EditSymptomForm = connect((state) => ({
  initialValues: state.editSymptom.symptomEditForm,
}))(EditSymptomForm);

class EditSymptom extends Component {
  constructor(props) {
    super(props);
    this.savePage = this.savePage.bind(this);
    this.savedAddItem = this.savedAddItem.bind(this);
    this.submitAfterAsk = this.submitAfterAsk.bind(this);
    this.resetNegativeFunction = this.resetNegativeFunction.bind(this);
    this.searchSymptom = this.searchSymptom.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.inputFileRef = React.createRef();
    this.addCustomAlert = this.addCustomAlert.bind(this);
    this.state = {
      dlModal: false,
      ingredientsVmodal: false,
      ingredientsVmodalData: "",
      deleteVid: "",
      appendBarcode: "",
      barcodeAlert: false,
      barcodeValue: this.props.barcodeValue,
      showUpdateText: false,
      compressingCount: 0,
      showTrendAfterSuccess: false,
    };
  }
  componentWillUnmount() {
    this.props.resetPage();
    if (this.cleanupPage) this.cleanupPage();
  }
  leave = (location) => {
    if (this.props.updatedList)
      return this.props.t("general.UNSAVED_LEAVE_PAGE_TEXT");
  };
  componentDidMount() {
    loginRequired();

    // ✅ Call helper that handles Contribution Cancelled for Chrome, Firefox, Safari & Edge
    // Product Not Contributed prompt display and recreate unsavedAlertData 
    this.cleanupPage = SetupPageWithBFCacheAndPrompt(this, {
      promptRefName: "ProductNotContributed",
      initCallback: () => {
        const bodyMapSymptom = localStorage.getItem("bodyMapSymptom");
        const selectedInfo = localStorage.getItem("selectedInfo");
        this.selectedInfo = JSON.parse(selectedInfo);
        const bodyreturnIsEdit = localStorage.getItem("bodyreturn");

        if (bodyMapSymptom && bodyreturnIsEdit == "editsymptoms") {
          this.props.bodyMapReturn();
        } else {
          this.loggedInUser = getLoggedInUser();
          this.props.editPageInitialization(this.loggedInUser._id);
          localStorage.removeItem("selectedInfo");
        }
      },
      // NEW: make sure we’re reading the latest storage on restores
      dirtyFlagKey: "previousPageIsDirty",
      onDirtyFlagChange: (exists) => {
        // Optional: if your page keeps any local state/Redux that depends on this flag,
        // clear it here when exists === false.
        // (Most pages don’t need anything here; the normalize step is enough.)
      },
    });

    // const bodyMapSymptom = localStorage.getItem("bodyMapSymptom");
    // const selectedInfo = localStorage.getItem("selectedInfo");
    // this.selectedInfo = JSON.parse(selectedInfo);
    // const bodyreturnIsEdit = localStorage.getItem("bodyreturn");

    // if (bodyMapSymptom && bodyreturnIsEdit === "editsymptoms") {
    //   this.props.bodyMapReturn();
    // } else {
    //   this.loggedInUser = getLoggedInUser();
    //   this.props.editPageInitialization(this.loggedInUser._id);
    //   localStorage.removeItem("selectedInfo")
    // }
  }

  onSuccess() {
    alert(this.props.t("general.SAVE_SUCCESSFULLY_TITLE"));
  }

  onSubmit(val) {
    let form = this.props.symptomEditForm;
    val = this.props.symptomEditForm;

    let uOptions = this.props.unitOptions.map((item) => {
      return item.value;
    });
    val.unitList = val.unitList || uOptions;
    let searchForm = this.props.searchForm;
    let data = {};
    // Add C

    // Determine whether it's custom or RefDB
    const isCustom =
      (!val.symptom || val.symptom.length === 0) &&
      (!val.upc || val.upc.length === 0);

    val.fullname = val.fullname.replace(/\s+/g, " ").trim(); // Remove double space and trailing space

    if (isCustom) {
      const CaseInsensitiveName = val.fullname.toLowerCase();

      if (CaseInsensitiveName.endsWith(" (c)")) {
        // If ends with " (C)", remove the space before (C)
        val.fullname = val.fullname.slice(0, -4) + " (C)";
      } else if (CaseInsensitiveName.endsWith("(c)")) {
        // if there's "(C)", just remove and add back. This handles the case of switching lower case "(c)" adding by user (if any) to the standard upper case "(C)"
        val.fullname = val.fullname.slice(0, -3) + " (C)";
      } else if (!CaseInsensitiveName.endsWith("(c)")) {
        // If there's no "(C)", append "(C)"
        val.fullname += " (C)";
      }
      val.name = val.fullname;
      val.displayname = val.fullname;
    }

    if (val.symptom.length === 0) {
      if (val.upc) {
        data.upc = val.upc;
      }
    } else if (val.symptom.length > 0) {
      let itemID = val.symptom.slice(0, 1);
      if (itemID === "6") {
        if (val.upc) {
          data.upc = val.upc;
        }
      }
    }
    // End C
    if (this.props.itemSelected.category === "01") {

      data = {
        _id: form.symptom,
        participant: searchForm.user,
        symptom: form.symptom,
        date: moment(form.time).unix() * 1000,
        type: form.type,
        severity: val.scale,
        unitid: val.unit || "",
        symptom_name: val.name,
        displayname: val.displayname,
        comment: form.comment || "",
        category: val.upc && val.upc != "" ? val.category : this.props.itemSelected.category,
        units: val.unitList,
        upc: val.upc,
        is_custom: val.is_custom,
      };
    } else if (val.category === "02") {
      data = {
        ...data,
        _id: val._id,
        participant: searchForm.user,
        date: moment(form.time).unix() * 1000,
        comment: form.comment || "",
        category: "02",
        units: val.unitList,
        is_custom: val.is_custom,
        meals: [
          {
            _id: form.symptom,
            size: val.scale,
            unitid: val.unit || "",
            units: val.units || [],
            recipe: val.displayname ? val.displayname : val.name,
            recipe_full: val.fullname,
            displayname: val.displayname,
            original_size: val.scale,
            ingredients_text: val.ingredients_text,
            category: "02",
            upc: val.upc
          },
        ],
      };

    } else {
      data = {
        ...data,
        is_custom: val.is_custom,
        participant: searchForm.user,
        //symptom: form.symptom,
        _id: form.symptom,
        date: moment(form.time).unix() * 1000,
        value: val.scale,
        unitid: val.unit || "",
        fullname: val.fullname,
        name: val.name,
        comment: form.comment || "",
        category: val.category,
        upc: val.upc,
        units: val.unitList,
        ingredients_text: val.ingredients_text,
      };
    }
    var addFlag = true;
    if (this.props.itemSelected.category === "01") {
      var symptoms = this.props.symptoms.filter(
        (item) => item.category == "01"
      );
      symptoms.forEach((item) => {
        // var newTime = {
        //   currentTime: data.date,
        //   nextTime: item.date + 300000,
        //   pastTime: item.date - 300000,
        // };
        if (
          item.symptom_name == data.symptom_name &&
          item.severity == data.severity &&
          item.comment == data.comment &&
          item.label == data.label &&
          item.date == data.date
          // newTime.currentTime > newTime.pastTime &&
          // newTime.currentTime < newTime.nextTime
        ) {
          if (addFlag) {
            // alert(this.props.t("general.DUPLICATE_ENTRY_ERROR_TEXT"));
          }
          // addFlag = false;
        }
      });
    } else if (this.props.itemSelected.category == "02" && val.category == "02") {
      var meals = this.props.symptoms.filter((item) => item.category == "02");
      meals.forEach((item) => {
        var newTime = {
          currentTime: data.date,
          nextTime: item.date + 300000,
          pastTime: item.date - 300000,
        };
        item = item.meals[0];
        if (
          item.recipe == data.meals[0].recipe &&
          item.comment == data.comment &&
          item.size == data.meals[0].size &&
          item.unitid == data.meals[0].unitid &&
          newTime.currentTime > newTime.pastTime &&
          newTime.currentTime < newTime.nextTime
        ) {
          if (addFlag) {
            alert(this.props.t("general.DUPLICATE_ENTRY_ERROR_TEXT"));
          }
          addFlag = false;
        }
      });
    }
    if (this.props.itemSelected.category === "03") {
      var activities = this.props.symptoms.filter(
        (item) => item.category == "03"
      );
      activities.forEach((item) => {
        //let comment = comment ? comment : "";
        var newTime = {
          currentTime: data.date,
          nextTime: item.date + 300000,
          pastTime: item.date - 300000,
        };
        if (
          item.name == data.name &&
          item.act_id == data._id &&
          item.value == data.value &&
          item.comment == data.comment &&
          item.unitid == data.unitid &&
          newTime.currentTime > newTime.pastTime &&
          newTime.currentTime < newTime.nextTime
        ) {
          // if (addFlag) {
          //   alert(this.props.t("general.DUPLICATE_ENTRY_ERROR_TEXT"));
          // }
          // addFlag = false;
        }
      });
    }
    if (this.props.itemSelected.category === "04") {
      var pcps = this.props.symptoms.filter((item) => item.category == "04");
      pcps.forEach((item) => {
        //let comment = comment ? comment : "";
        var newTime = {
          currentTime: data.date,
          nextTime: item.date + 300000,
          pastTime: item.date - 300000,
        };
        if (
          item.name == data.name &&
          item.pcp_id == data._id &&
          item.value == data.value &&
          item.comment == data.comment &&
          item.units[0] == data.unitid &&
          newTime.currentTime > newTime.pastTime &&
          newTime.currentTime < newTime.nextTime
        ) {
          // if (addFlag) {
          //   alert(this.props.t("general.DUPLICATE_ENTRY_ERROR_TEXT"));
          // }
          // addFlag = false;
        }
      });
    }
    if (this.props.itemSelected.category === "05") {
      var drugs = this.props.symptoms.filter((item) => item.category == "05");
      drugs.forEach((item) => {
        //let comment = comment ? comment : "";
        var newTime = {
          currentTime: data.date,
          nextTime: item.date + 300000,
          pastTime: item.date - 300000,
        };
        if (
          item.name == data.name &&
          item.drug_id == data._id &&
          item.value == data.value &&
          item.comment == data.comment &&
          item.units[0] == data.unitid &&
          newTime.currentTime > newTime.pastTime &&
          newTime.currentTime < newTime.nextTime
        ) {
          // if (addFlag) {
          //   alert(this.props.t("general.DUPLICATE_ENTRY_ERROR_TEXT"));
          // }
          // addFlag = false;
        }
      });
    }
    if (this.props.itemSelected.category === "06") {
      var supplements = this.props.symptoms.filter(
        (item) => item.category == "06"
      );
      supplements.forEach((item) => {
        //let comment = comment ? comment : "";
        var newTime = {
          currentTime: data.date,
          nextTime: item.date + 300000,
          pastTime: item.date - 300000,
        };
        if (
          item.name == data.name &&
          item.item_id == data._id &&
          item.value == data.value &&
          item.comment == data.comment &&
          item.units[0] == data.unitid &&
          newTime.currentTime > newTime.pastTime &&
          newTime.currentTime < newTime.nextTime
        ) {
          // if (addFlag) {
          //   alert(this.props.t("general.DUPLICATE_ENTRY_ERROR_TEXT"));
          // }
          // addFlag = false;
        }
      });
    }
    if (this.props.itemSelected.category === "07") {
      var locations = this.props.symptoms.filter(
        (item) => item.category == "07"
      );
      locations.forEach((item) => {
        //let comment = comment ? comment : "";
        var newTime = {
          currentTime: data.date,
          nextTime: item.date + 300000,
          pastTime: item.date - 300000,
        };
        if (
          item.name == data.name &&
          item.item_id == data._id &&
          item.value == data.value &&
          item.comment == data.comment &&
          item.units[0] == data.unitid &&
          newTime.currentTime > newTime.pastTime &&
          newTime.currentTime < newTime.nextTime
        ) {
          // if (addFlag) {
          //   alert(this.props.t("general.DUPLICATE_ENTRY_ERROR_TEXT"));
          // }
          // addFlag = false;
        }
      });
    }
    if (addFlag) {
      this.props.updateSymptom(
        data,
        this.props.itemSelected.category,
        this.onSuccess
      );
    }
  }
  searchClicked(val) {
    if (this.props.updatedList || this.props.itemChanged) {
      if (!this.props.disabled.addBtn || this.props.itemChanged) {
        this.setState({ showUpdateText: true });
      } else {
        this.setState({ showUpdateText: false });
      }
      this.dataInFormValert3.changeStatus();
      this.searchValues = val;
    } else {
      this.searchSymptom(val);
    }
  }
  searchSymptom(val) {
    val.start = this.props.searchForm.start;
    this.props.getSymptomList(val);
  }
  symptomSelected(item, index) {
    if (item.updatedData && !item.updatedData._id) {
      item.updatedData._id = "";
    }
    if (this.props.itemChanged) {
      this.item = item;
      this.index = index;
      this.CurrentItemNotUpdated.changeStatus();
    } else {
      this.props.symptomSelected(item, item.category, index);
    }
    this.selectedInfo = {
      item: item,
      category: item.category,
      index: index,
    };
    localStorage.setItem("selectedInfo", JSON.stringify(this.selectedInfo))
  }
  savePage() {
    this.props.savePage(
      this.props.symptoms,
      this.props.searchForm.category,
      () => {
        setTimeout(() => {
          // window.location.reload();
        }, 1000);
      }
    );
  }
  submitAfterAsk() {
    this.props.savePage(
      this.props.symptoms,
      this.props.searchForm.category,
      // () => {
      //   //alert("successfull!");
      //   this.props.history.push("/");
      // },
      () => {
        // alert("successfull!");
        // setTimeout(() => {
        //   this.props.history.push("/");
        // }, 1000);
        setTimeout(() => {
          this.props.history.push("/");
        }, 2000);
      }
    );
  }
  savedAddItem() {
    this.editSform.forceSubmit();
  }
  ingredientsModalHandler(title, ingredients_text) {
    let returnHTml = (
      <div className="ingredientsAreaInMealPlanner">
        <h4>{title}</h4>
        <ul>
          <span style={{ fontWeight: 500 }}>
            {this.props.t("symptoms.INGREDIENT_TEXT")}
          </span>
          <span style={{ fontSize: 14, color: "#333" }}>
            {ingredients_text}
          </span>
        </ul>
      </div>
    );

    this.setState({
      ingredientsVmodal: true,
      ingredientsVmodalData: returnHTml,
    });
  }
  onChangeSearchForm(e) {
    this.props.onChangeSearchForm(e);
  }
  onDateChangeSearch(e) {
    e.set({ h: 0, m: 0, s: 0 });
    let startDate = moment(e).startOf("day").unix() * 1000;
    this.props.onDateChangeSearch(e);
  }
  exportDateChanges(e) {
    e.set({ h: 0, m: 0, s: 0 });
    this.props.exportDateChanges(e);
  }
  categorySelected(e) {
    this.props.categorySelected(e);
  }
  resetNegativeFunction(name) {
    var val = "";
    switch (name) {
      case "category":
        val = this.props.searchForm.category;
        break;
      case "start":
        val = this.props.searchForm.start;
        break;
      case "to":
        val = this.props.searchForm.to;
        break;
      case "user":
        val = this.props.searchForm.user;
        break;
    }
    this.props.searchFormChanger(name, val);
  }
  async bodyMapClicked() {
    await this.props.bodyMapStart();
    localStorage.setItem("bodyreturn", "editsymptoms");
    if (!this.props.disabled.saveBtn) {
      sessionStorage.setItem("previousPageIsDirty", "edit"); // Set previousPageIsDirty if Save Page button is enabled
    }
    window.location.href = "/bodymap";
  }
  DeleteIconClicked = (id) => {
    this.setState({ deleteVid: id });
    this.deleteValert.changeStatus();
  };
  barcodeAlert = () => {
    this.barcodeAlertStatus.changeStatus();
  };
  barcodeImageAlert() {
    // this.barcodeAlertStatus.changeStatus();
    this.inputFileRef.current.click();
  }
  async submitUpcImage(image) {
    if (!image) return;

    this.startCompress();
    let fileToSend = image;
    try {
      // fileToSend = image.size > 1000000 ? await compressImageSmart(image) : image;

      // 1) Only compress when > 1MB (your existing helper)
      if (fileToSend.size > 1000000) {
        fileToSend = await compressImageSmart(fileToSend);
      }

      // 2) Always sanitize-encode (avoid WAF/ALB false positives)
      fileToSend = await sanitizeEncodeImage(fileToSend, {
        mimeType: "image/jpeg",
        quality: 0.88,  // or 0.90 if you prefer, but 0.88 is safer
        maxDim: 2048,
      });

      console.log("[upload] final", fileToSend.type, fileToSend.size, fileToSend.name);

    } finally {
      this.endCompress();
    }

    this.props.onSubmitUpcImage(fileToSend, this.props.symptomEditForm.category);
  }

  startCompress = () =>
    this.setState(s => ({
      compressingCount: s.compressingCount + 1
    }));

  endCompress = () =>
    this.setState(s => {
      const next = Math.max(0, s.compressingCount - 1);
      return { compressingCount: next };
    });

  addBarcodeToField() {
    this.setState({
      appendBarcode: this.props.upc404,
    });
    let contDefault = {
      page: "editsymptoms",
      barcode: this.props.upc404Value,
      symptoms: this.props.symptoms,
      symptomEditForm: this.props.symptomEditForm,
      searchForm: this.props.searchForm,
      category: this.props.symptomEditForm.category,
      selectedIndex: this.props.selectedIndex,
      itemSelected: this.props.itemSelected,
      unitOptions: this.props.unitOptions,
      searchMode: this.props.searchMode,
      selectedInfo: this.props.selectedInfo,
      defaultDate: moment(this.props.symptomEditForm.time).unix() * 1000,
      buttonStatus: {
        ...this.props.disabled,
        updatedList: this.props.updatedList,
      },
    };
    let defaultVal = JSON.stringify(contDefault);
    localStorage.setItem("contDefault", defaultVal);
  }
  onBarcodeSearch = () => {
    this.props.barcodeSearch(
      this.state.barcode,
      this.props.symptomEditForm.category
    );
    this.setState({ barcodeValue: this.state.barcode });
    this.setState({ barcode: "" });
  };

  addCustomAlert() {
    this.props.searchNameOptions("", "", true);
    this.addCustomVAlert.changeStatus();
  }

  addGreyUPC = () => {
    let contDefault = JSON.parse(localStorage.getItem("contDefault"));
    if (contDefault && contDefault.barcode) {
      this.props.addGreyUPCToItemNameField(contDefault.barcode);
      this.props.searchNameOptions("", "", false, true); // Do not clear UPC
      localStorage.removeItem("contDefault"); // ✅ Clear after clicking Continue button
      localStorage.removeItem("unContributed");
    }
  };

  render() {
    const symptoms = Array.isArray(this.props.symptoms) ? this.props.symptoms : [];

    const visibleSymptoms = symptoms.filter((item) => item.status !== 2);

    const showDeletedDataText =
      Array.isArray(this.props.symptoms) &&
      visibleSymptoms.length === 0 &&
      !!this.props.updatedList;
    const {
      t,
      onChangeSyptomEditForm,
      deleteMode,
      updateMode,
      categories,
      ListOfWhile,
      itemSelected,
      symptomEditForm,
      isLoading,
    } = this.props;

    // Display Area Month Translation Helper
    const formatDateTimeLocalized = (date, { includeTime = true } = {}) => {
      const d = moment(date);

      // language: prefer i18next.language; fallback to localStorage; default 'en'
      const lang = (typeof window !== "undefined" && window.localStorage && localStorage.getItem("i18nextLng")) || "en";
      const isEn = String(lang).toLowerCase().startsWith("en");

      // month label: EN → short (MMM); others → full via your translation keys
      const monthEnFull = d.clone().locale("en").format("MMMM").toUpperCase();
      const translatedFullMonth = this.props.t(`meal_plan_summary.${monthEnFull}`);
      const monthLabel = isEn ? d.clone().locale("en").format("MMM") : translatedFullMonth;

      // ⚡ NOTE: Year removed. Time changed to 'hh:mma' (no space before AM/PM)
      let base = `${d.format("DD")} ${monthLabel}`;

      if (includeTime) {
        let timeStr = d.format("hh:mma");
        timeStr = timeStr.replace("am", "a").replace("pm", "p");
        base = `${base} ${timeStr}`;
      }

      return base;
    };

    const selectedRowId = (itemSelected && itemSelected.orgItem && itemSelected.orgItem._id) || (itemSelected && itemSelected._id);


    return (
      <div className="vPage symptom flex symptom-modern">
        {/*Show loading icon whenever Redux is loading OR we’re compressing:*/}
        <Loading isLoading={isLoading || this.state.compressingCount > 0} />
        <input
          style={{ display: "none" }}
          // key={this.state.barcodeKey || ""}
          type="file"
          name="file"
          id="upc-img"
          ref={this.inputFileRef}
          accept="image/*"
          multiple={false}
          onChange={(e) => {
            e.preventDefault();
            e.target.files && e.target.files.length > 0
              ? this.submitUpcImage(e.target.files[0])
              : null;
          }}
          onClick={(e) => (e.target.value = null)}
        />
        <Vmodal
          zIndex={12}
          displayStatus={this.state.ingredientsVmodal}
          data={this.state.ingredientsVmodalData}
          closeFunc={() => {
            this.setState({
              ingredientsVmodal: false,
              ingredientsVmodalData: "",
            });
          }}
        />
        <Vmodal
          displayStatus={this.props.saveSuccess}
          data={
            <div className="mb-4">
              <h4>{this.props.t("general.SAVE_SUCCESSFULLY_TITLE")}</h4>
              <p>{this.props.t("meal_planner.SAVE_SUCCESSFULLY_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            if (this.props.NewTrendFound) {
              // 1) Hide success modal (unbind displayStatus)
              this.props.dismissEditSaveSuccess();
              // 2) Then show Trend Alert
              this.setState({ showTrendAfterSuccess: true });
            } else {
              this.props.clearEditSymptom();
              window.location.reload();
            }
          }}
          timedClose={2000}
        />

        <Valert
          display={this.state.showTrendAfterSuccess}
          title={t("general.TREND_ALERT_TITLE")}
          question={t("general.TREND_ALERT_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            // After acknowledging Trend Alert, finish the flow
            this.props.clearEditSymptom();
            window.location.reload();
          }}
          readOnly={true}
        />
        <Valert
          display={this.props.saveError.type && this.props.saveError.type === "identicalRegimen"}
          title={this.props.t("editsymptoms.IDENTICAL_ERROR_TITLE")}
          question={this.props.t("editsymptoms.IDENTICAL_ERROR_TEXT")}
          children={
            this.props.saveError && this.props.saveError.meta && this.props.saveError.meta.length > 0 && (
              <ListingText listing={this.props.saveError.meta.map(m => ({ value: m }))} />
            )
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.clearEditSymptom();
          }}
          readOnly={true}
        />
        <Valert
          display={this.props.saveError.type && this.props.saveError.type === "alreadyUsedRecipeName"}
          title={t("recipe.ALREADY_USED_RECIPE_NAME_TITLE")}
          question={t("recipe.ALREADY_USED_RECIPE_NAME_TEXT")}
          children={
            this.props.saveError && this.props.saveError.meta && this.props.saveError.meta.length > 0 && (
              <ListingText listing={this.props.saveError.meta.map(m => ({ value: m }))} />
            )
          }
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.clearEditSymptom();
          }}
          readOnly={true}
        />
        <Valert
          display={this.props.incorrectBarcodeCategory}
          title={this.props.t("BARCODE.INCORRECT_BARCODE_CATEGORY_TITLE")}
          question={t("BARCODE.INCORRECT_BARCODE_CATEGORY_EDIT_PAGE")}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeAction={() => {
            this.props.searchNameOptions("", "", true);
          }}
          positiveAction={() => {
            this.props.symptomOptionSelected(this.props.itemData);

            if (this.props.showVerificationPrompt === true) {
              this.props.onChangeAlertStatus({
                showVerificationPrompt: false,
                itemInVerAutofill: true,
                incorrectBarcodeCategory: false,
              });
            }
          }}
        />
        <Valert
          display={this.props.upc404}
          title={this.props.t("BARCODE.UPC404_ERROR_TITLE")}
          question={this.props.t("BARCODE.UPC404_ERROR_TEXT.TEXT")}
          positiveAction={async () => {
            await this.addBarcodeToField(); // Assign scanned/uploaded UPC to form
            if (!this.props.disabled.saveBtn) {
              sessionStorage.setItem("previousPageIsDirty", "edit"); // Set previousPageIsDirty if Save Page button is enabled
            }
            window.location.href = "/contribute?showBackBtn=true"; // Navigate to Contribute page

            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          positiveText={this.props.t("general.CONTRIBUTE")}
          negativeText={this.props.t("general.CANCEL")}
          negativeAction={() => {
            this.props.searchNameOptions("", "", false, true);
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          onRef={(ref) => (this.contributeRedirectionAlert = ref)}
          disableAutoClose={true}
          thirdActionText={this.props.t("general.NEW")}
          ThirdAction={() => {
            this.props.searchNameOptions("", "", true);
            this.props.resetContributeAlertState(); // Clear the redux state so that upon returning back from Contribute Data page, the prompt is not shown again. This is critical for Firefox and Safari where pages are reloaded from memory (bfcache or page cache) rather than full fresh reload
          }}
          children={<ListingText listing={this.props.listings} />}
        />
        <Valert
          display={this.props.itemInVerAutofill}
          onRef={(ref) => (this.itemInVerAutofillRef = ref)}
          title={t("symptoms.ITEM_IN_VERIFICATION_TITLE")}
          question={t("symptoms.ITEM_IN_VERIFICATION_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.symptomOptionSelected(this.props.itemData);

            this.props.onChangeAlertStatus({
              itemInVerAutofill: false,
            });
          }}
          readOnly={true}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.barcodeVerification = ref)}
          title={t("symptoms.BARCODE_VERIFICATION_TITLE")}
          question={t("symptoms.BARCODE_VERIFICATION_TEXT")}
          positiveAction={() => {
            this.addBarcodeToField();
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          title={
            this.props.symptomEditForm.category === "01"
              ? this.props.t("general.OUT_RANGE_AMOUNT_TITLE")
              : this.props.t("general.OUT_RANGE_AMOUNT_TITLE")
          }
          question={
            this.props.symptomEditForm.category === "01"
              ? this.props.t("general.OUT_RANGE_SEVERITY_SYMPTOM_TEXT")
              : this.props.t("general.OUT_RANGE_AMOUNT_TEXT")
          }
          onRef={(ref) => (this.rangeCheck = ref)}
          positiveAction={() => {
            if (this.editSform.pendingCustomCheck && typeof this.editSform.pendingCustomCheck === "function") {
              const handled = this.editSform.pendingCustomCheck();
              this.editSform.pendingCustomCheck = null;
              if (handled) return; // stop if we fully handled the next step
            }

            this.onSubmit();
          }}
        />
        <Valert
          display={false}
          title={this.props.t("editsymptoms.UNSAVED_EDITED_ONEXPORT_TITLE")}
          question={!this.state.showUpdateText
            ? this.props.t("editsymptoms.UNSAVED_EDIT_TEXT")
            : this.props.t("editsymptoms.UNSAVED_EDITED_ONEXPORT_TEXT")}
          onRef={(ref) => (this.dataInFormValert3 = ref)}
          //positiveAction={this.selectItemPos}
          disableAutoClose={true}
          positiveAction={() => {
            if (this.state.showUpdateText) {
              this.setState({ showUpdateText: false });
            } else {
              this.dataInFormValert3.changeStatus();
              this.searchSymptom(this.searchValues);
            }
          }}
          negativeAction={() => {
            this.dataInFormValert3.changeStatus();
          }}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={this.props.t("general.CURRENT_ITEM_TITLE")}
          question={this.props.t("general.CURRENT_ITEM_TEXT")}
          onRef={(ref) => (this.CurrentItemNotUpdated = ref)}
          //positiveAction={this.selectItemPos}
          positiveAction={() => {
            this.props.symptomSelected(
              this.item,
              this.item.category,
              this.index
            );
          }}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={this.props.t("general.WARNING_TITLE")}
          question={this.props.t("editsymptoms.NO_SAVE_LEAVE_TEXT")}
          onRef={(ref) => (this.noSaveBeforExitValert = ref)}
          positiveAction={this.savedAddItem}
        />
        <Valert
          display={this.props.exportSuccess}
          title={this.props.t("general.CHECK_EMAIL_TITLE")}
          question={this.props.t("general.EDITPAGE_CHECK_EMAIL_TEXT")}
          positiveText={this.props.t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.props.clearModal();
            this.props.exportDateChanges(this.props.searchForm.start);
          }}
          readOnly={true}
        />
        <Valert
          display={false}
          title={this.props.t("symptoms.OTHER_ENTRY_ERROR_TITLE")}
          question={this.props.t("symptoms.OTHER_ENTRY_ERROR_TEXT")}
          onRef={(ref) => (this.CustomItemNotIn12u12DB = ref)}
          positiveAction={() => {
            this.savedAddItem();
          }}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={
            symptomEditForm &&
              itemSelected &&
              this.props.itemChanged &&
              this.state.deleteVid != selectedRowId
              ? t("general.CURRENT_ITEM_TITLE")
              : t("general.DELETE_CONFIRMATION_TITLE")
          }
          question={
            symptomEditForm &&
              itemSelected &&
              this.props.itemChanged &&
              this.state.deleteVid != selectedRowId
              ? t("general.CURRENT_ITEM_DELETE_TEXT")
              : t("general.DELETE_CONFIRMATION_TEXT")
          }
          onRef={(ref) => (this.deleteValert = ref)}
          positiveAction={() => {
            this.props.deleteSymptom(this.state.deleteVid);
          }}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={this.props.t("editsymptoms.UNSAVED_EDITED_ONEXPORT_TITLE")}
          question={this.props.t("editsymptoms.UNSAVED_EDIT_TEXT")}
          onRef={(ref) => (this.resetFormalert = ref)}
          positiveAction={() => {
            this.resetFormFunction(this.resetFormalertValue);
          }}
          negativeAction={() => {
            this.resetNegativeFunction(this.resetNegativeVal);
          }}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Valert
          display={false}
          title={this.props.t("general.ENTER_BARCODE")}
          // question={"Type your barcode below"}
          onRef={(ref) => (this.barcodeAlertStatus = ref)}
          inputField={true}
          inputType={"number"}
          showInvalid={false}
          positiveAction={this.onBarcodeSearch}
          inputValue={this.state.barcode}
          onChangeInput={(e) => this.setState({ barcode: e.target.value })}
          positiveText={this.props.t("general.SUBMIT")}
          negativeText={this.props.t("general.CANCEL")}
          negativeAction={() => this.setState({ barcode: "" })}
          okBtn={
            this.state.barcode && this.state.barcode.length > 3 ? false : true
          }
        />
        <Valert
          display={this.props.addCustomAlert}
          onRef={(ref) => (this.addCustomVAlert = ref)}
          title={t("BARCODE.OTHER_ENTRY_ERROR_TITLE")}
          question={
            this.props.symptomEditForm.category === "02"
              ? t("BARCODE.OTHER_ENTRY_ERROR_FOOD_CATEGORY_TEXT")
              : t("BARCODE.OTHER_ENTRY_ERROR_OTHER_CATEGORIES_TEXT")
          }
          positiveAction={() => {
            this.props.onDateChange("");
            this.setState({
              barcode: this.state.barcodeValue,
              displayAddCustomAlert: false,
            });
            this.setState({ barcodeValue: "" });
            this.barcodeAlertStatus.changeStatus();
            this.props.onChangeAlertStatus({
              item: { addCustomAlert: false },
            });
          }}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={this.props.barcodeFailed}
          onRef={(ref) => (this.barcodeFailed = ref)}
          title={t("BARCODE.BARCODE_ERROR_TITLE")}
          question={t("BARCODE.BARCODE_ERROR_TEXT")}
          // positiveAction={}
          positiveText={t("general.OK_PROMPT_TEXT")}
          readOnly={true}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.ProductNotContributed = ref)}
          title={this.props.t("general.PRODUCT_NOT_CONTRIBUTED_TITLE")}
          question={this.props.t("general.PRODUCT_NOT_CONTRIBUTED_TEXT")}
          positiveAction={this.addGreyUPC} // Call function to handle adding grey UPC to the Item Name field
          positiveText={t("general.CONTINUE_BUTTON")}
          negativeText={t("general.NEW")}
          negativeAction={() => {
            this.props.searchNameOptions("", "", true); // Clear UPC from Item Name field
            localStorage.removeItem("contDefault"); // ✅ Clear after clicking New button
            localStorage.removeItem("unContributed");
          }}
          children={
            <div style={{ fontSize: 14.4, color: "#555555", marginTop: 0 }}>
              <ul style={{ listStyleType: "disc", marginLeft: 12 }}>
                <li style={{ marginBottom: 5 }}>
                  {this.props.t("general.PRODUCT_NOT_CONTRIBUTED_BULLET1_TEXT")}
                </li>
                <li>
                  {this.props.t("general.PRODUCT_NOT_CONTRIBUTED_BULLET2_TEXT")}
                </li>
              </ul>
            </div>
          }
        />

        <MuiThemeProvider>
          <SearchSymptomForm
            t={this.props.t}
            disabled={this.props.disabled}
            searchForm={this.props.searchForm}
            category={this.props.searchForm.category}
            users={this.props.users}
            onSubmit={this.searchClicked.bind(this)}
            categorySelected={this.categorySelected.bind(this)}
            onChangeSearchForm={this.onChangeSearchForm.bind(this)}
            onDateChangeSearch={this.onDateChangeSearch.bind(this)}
            searchBtn={this.props.disabled.searchBtn}
            categories={categories}
            ListOfWhile={ListOfWhile}
            searchMode={this.props.searchMode}
            symptomExport={this.props.symptomExport}
            exportDateChanges={this.exportDateChanges.bind(this)}
            itemChanged={this.props.itemChanged}
            updatedList={this.props.updatedList}
            symptomSelected={this.props.symptomSelected}
            selectedInfo={this.selectedInfo}
            resetNegativeFunction={this.resetNegativeFunction}
            cancelMode={this.props.cancelMode}
            selectedItem={this.props.itemSelected}
            selectedIndex={this.props.selectedIndex}
          ></SearchSymptomForm>
        </MuiThemeProvider>
        <div className="grayList editSymptomList" style={{ flex: 1 }}>
          {/* {(!this.props.symptoms ||
            this.props.symptoms < 1 ||
            this.props.symptoms === 404) && (
              <div className="usersItem">
                <Row style={{ padding: "4px 0 4px 4px" }}>
                  <Col>
                    <span className="desc"></span>
                    {this.props.symptoms === 404
                      ? this.props.t("general.NO_DATA_FOUND_TEXT")
                      : this.props.t("general.SEARCH_REQUIRED_TEXT")}
                  </Col>
                </Row>
              </div>
            )} */}
          {(this.props.symptoms === 404 ||
            !this.props.symptoms ||
            (Array.isArray(this.props.symptoms) && visibleSymptoms.length === 0)) && (
              <div className="usersItem">
                <Row style={{ padding: "4px 0 4px 4px" }}>
                  <Col>
                    <span className="desc"></span>
                    {showDeletedDataText
                      ? this.props.t("general.DELETED_DATA_DISPLAY_AREA_TEXT")
                      : this.props.symptoms === 404
                        ? this.props.t("general.NO_DATA_FOUND_TEXT")
                        : this.props.t("general.SEARCH_REQUIRED_TEXT")}
                  </Col>
                </Row>
              </div>
            )}
          {this.props.symptoms &&
            this.props.symptoms !== 404 &&
            this.props.symptoms.map((item, index) => {
              let sunits = [];
              let unitName = [];
              let sunitid = [];
              let category = item.category;
              if (item.status == 1) {
                category = item.updatedData.category;
              }
              if (category == "01") {
                sunits = SYMPTOM_UNITS_NEW();
                sunitid = item.updatedData
                  ? item.updatedData.unitid
                  : item.unitid;
                for (const sunit of sunits) {
                  if (sunit._id == sunitid && sunit.unit != "Unit") {
                    unitName = (sunit.displayunit || "").trim();
                  }
                }
              } else if (category == "03") {
                sunits = ACTIVITY_UNITS();
                sunitid = item.updatedData
                  ? item.updatedData.unitid
                  : item.unitid;
                for (const sunit of sunits) {
                  if (sunit._id == sunitid) {
                    unitName = (sunit.displayunit || "").trim();
                  }
                }
              } else if (category == "04") {
                sunits = PCP_UNITS();
                sunitid = item.updatedData
                  ? item.updatedData.unitid
                  : item.units[0];
                for (const sunit of sunits) {
                  if (sunit._id == sunitid) {
                    unitName = (sunit.displayunit || "").trim();
                  }
                }
              } else if (category == "05") {
                sunits = DRUG_UNITS();
                sunitid = item.updatedData
                  ? item.updatedData.unitid
                  : item.units[0];
                for (const sunit of sunits) {
                  if (sunit._id == sunitid) {
                    unitName = (sunit.displayunit || "").trim();
                  }
                }
              } else if (category == "06") {
                sunits = SUP_UNITS();
                sunitid = item.updatedData
                  ? item.updatedData.unitid
                  : item.units[0];
                for (const sunit of sunits) {
                  if (sunit._id == sunitid) {
                    unitName = (sunit.displayunit || "").trim();
                  }
                }
              } else if (category == "07") {
                sunits = LOC_UNITS();
                sunitid = item.updatedData
                  ? item.updatedData.unitid
                  : item.unitid;
                for (const sunit of sunits) {
                  if (sunit._id == sunitid) {
                    unitName = (sunit.displayunit || "").trim();
                  }
                }
              } else if (category == "02") {
                sunits = FOOD_UNITS();
                sunitid = item.updatedData
                  ? item.updatedData.meals[0].unitid
                  : item.meals[0].unitid;
                for (const sunit of sunits) {
                  if (sunit._id == sunitid) {
                    unitName = (sunit.displayunit || "").trim();
                  }
                }
              }

              if (item.status != 2) {
                const class_name = "usersItem";
                var data = item.status == 1 ? item.updatedData : item;
                let name = "";
                let fullname = "";
                let scale = "";
                let unit = "";
                let ingredients = "";

                if (category === "01") {
                  name = data.displayname;
                  scale = (data.severity || "").toString().trim();
                  unit = unitName;
                } else if (category === "02") {
                  name = data.meals[0].recipe;
                  scale = (data.meals[0].size || "").toString().trim();
                  unit = unitName;
                  fullname = data.meals[0].recipe_full;
                  ingredients = data.meals[0].ingredients_text;
                  let itemID = data.meals[0]._id;
                  itemID = itemID.slice(0, 1);
                  if (itemID == "6" && data.meals[0].upc) {
                    data.upc = data.meals[0].upc;
                  }
                } else {
                  if (data.name == data.fullname && data.upc) {
                    data.upc = data.upc;
                  }
                  name = data.name;
                  scale = (data.value || "").toString().trim();
                  unit = unitName;
                  ingredients = data.ingredients_text;
                  fullname = data.fullname;
                }
                // const occurrenceDate = moment(data.date)
                //   .format("DD MMM hh:mma")
                //   .slice(0, -1);
                return (
                  <div key={index} className="usersItem">
                    <Row
                      className={"wrapper" + (item.selected ? " selected" : "")}
                      onClick={this.symptomSelected.bind(this, item, index)}
                    >
                      <Col className="dateColumn" xs="2 pl-0">
                        {formatDateTimeLocalized(data.date, { includeTime: true })}
                      </Col>

                      <Col xs="2">
                        {scale}
                        {unit ? ` ${unit}` : ""}
                      </Col>
                      <Col xs="7 pl-0">
                        {name}
                        {data.upc ? `(${data.upc})` : ""}
                      </Col>
                      <Col
                        className={
                          ingredients && ingredients.length > 0
                            ? "d-flex justify-content-between"
                            : "d-flex justify-content-end"
                        }
                        xs="1"
                        style={{ paddingTop: "3px", marginLeft: "7.4px" }}
                      >
                        {ingredients && ingredients.length > 0 && (
                          // <i
                          //   className="fas fa-info deleteIcon ml-0"
                          //   style={{ color: "#007bff" }}
                          //   onClick={(e) => {
                          //     e.stopPropagation();
                          //     this.ingredientsModalHandler(
                          //       fullname,
                          //       ingredients
                          //     );
                          //   }}
                          // />
                          <FontAwesomeIcon
                            className="fas fa-info-circle deleteIcon ml-0"
                            icon={faCircleInfo}
                            style={{
                              color: "#007bff",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.ingredientsModalHandler(
                                fullname,
                                ingredients
                              );
                            }}
                          />
                        )}
                        <i
                          className="far fa-trash-alt deleteIcon"
                          style={{
                            marginLeft: "7px",
                            paddingLeft: "5px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();

                            this.DeleteIconClicked(item._id);
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                );
              }
            })}
        </div>
        <MuiThemeProvider>
          <EditSymptomForm
            t={this.props.t}
            disabled={this.props.disabled}
            onSubmit={this.onSubmit}
            //nameOptions={this.props.nameOptions}
            scaleOptions={this.props.scaleOptions}
            unitOptions={this.props.unitOptions}
            searchNameOptions={this.props.searchNameOptions}
            nameTotalOptions={this.props.nameTotalOptions}
            symptomEditForm={this.props.symptomEditForm}
            searchForm={this.props.searchForm}
            symptoms={this.props.symptoms}
            symptomOptionSelected={this.props.symptomOptionSelected}
            updateSymptom={this.props.updateSymptom}
            onDateChange={this.props.onDateChange}
            deleteSymptom={() => this.deleteValert.changeStatus()}
            deleteMode={deleteMode}
            updateMode={updateMode}
            onChangeSyptomEditForm={onChangeSyptomEditForm}
            savePage={this.savePage}
            currentCategory={this.props.searchForm.category}
            amounNewValue={this.props.amounNewValue}
            amountReseter={this.props.amountReseter}
            CustomItemNotIn12u12DB={this.CustomItemNotIn12u12DB}
            onRef={(ref) => (this.editSform = ref)}
            itemSelected={itemSelected}
            bodyMapClicked={this.bodyMapClicked.bind(this)}
            rangeCheck={this.rangeCheck}
            outOfRange={this.props.outOfRange}
            cancelMode={this.props.cancelMode}
            itemChanged={this.props.itemChanged}
            selectedIndex={this.props.selectedIndex}
            symptomSelected={this.props.symptomSelected}
            barcodeClicked={this.barcodeAlert}
            barcodeImageClicked={this.barcodeImageAlert.bind(this)}
            selectedCategory={this.props.selectedCategory}
            partialResult={this.props.partialResult}
            barcodeSearch={this.props.barcodeSearch}
            barcode={this.props.upc404}
            addCustomAlert={this.addCustomAlert}
            hhmmMode={this.props.hhmmMode}
            setHHMMMode={this.props.setHHMMMode}
            clearEditSymptom={this.props.clearEditSymptom}
          ></EditSymptomForm>
        </MuiThemeProvider>
      </div>
    );
  }
}

EditSymptom = translate("translations")(EditSymptom);

const mapStateToProps = (state) => ({
  ...state.editSymptom,
  formEditSymptom: state.form.formEditSymptom,
  formSymptom: state.form.formSymptom,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...editSymptomActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(EditSymptom);



// WEBPACK FOOTER //
// ./src/pages/EditSymptom.js